import { render } from "./ObjectiveSection.vue?vue&type=template&id=fdf3194a&scoped=true"
import script from "./ObjectiveSection.vue?vue&type=script&lang=js"
export * from "./ObjectiveSection.vue?vue&type=script&lang=js"

import "./ObjectiveSection.vue?vue&type=style&index=0&id=fdf3194a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdf3194a"]])

export default __exports__